import { render } from "./Settings-LanguageAndOtherOptions.vue?vue&type=template&id=df14f688&scoped=true"
import script from "./Settings-LanguageAndOtherOptions.vue?vue&type=script&lang=js"
export * from "./Settings-LanguageAndOtherOptions.vue?vue&type=script&lang=js"

import "./Settings-LanguageAndOtherOptions.vue?vue&type=style&index=0&id=df14f688&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-df14f688"]])

export default __exports__